(function () {
  // const faqCategories = [127, 128, 122, 126, 125];
  const form = document.querySelector('#knowledge-search-form');
  let faqCards = document.querySelectorAll('.knowledge-list__item');
  const search = form.querySelector('#faq-search');
  const noResultsSection = document.querySelector('.empty-search-results');

  for (card of faqCards) {
    card.classList.add('current');
  }

  function hideCards(cards) {
    if (!cards.length) {
      noResultsSection.style.display = 'block';
    } else noResultsSection.style.display = 'none';
  }

  hideCards(faqCards);

  const searchPosts = (event) => {
    if (event.target.tagName.toLowerCase() === 'form') event.preventDefault();
    const searchValue = search.value.trim().toLowerCase();
    const currentFilter = $('input[name=category]:checked').val();
    const visibleCards = [];

    Array.from(faqCards).forEach((card) => {
      card.classList.remove('current');
      const cardTitle = card.querySelector('h3');
      const value = cardTitle.textContent.toLowerCase();
      const categories = card.dataset.categories.split(',');

      if (
        value.indexOf(searchValue) > -1 &&
        (categories.includes(currentFilter) || currentFilter === '')
      ) {
        card.classList.remove('hidden');
        visibleCards.push(card);
        card.classList.add('current');
      } else {
        card.classList.add('hidden');
      }

      hideCards(visibleCards);
    });
  };

  form.addEventListener('submit', searchPosts);

  $('.category-filter').on('change', searchPosts);
})();
